module.exports = __webpack_public_path__ + "static/media/offer_ad_image.ce4be75f.png";